<ion-footer id="app-footer">
  <ion-toolbar color="primary">
    <ion-label slot="start" class="footer-label-start">CAM Time-Clock
      <ion-text *ngIf="(isKioskMode$ | async) && inactivity.remaining > 0">
        &nbsp;(sign-out in:&nbsp;{{ inactivity.remaining }}s)
      </ion-text>
    </ion-label>
    <ion-label slot="end" class="footer-label-end">Version:&nbsp;{{ version }} ({{ mode }})</ion-label>
  </ion-toolbar>
</ion-footer>
